import api from "../../api/api";
import API_URL from "../../api/url";
import axios from "axios";

const BookingTypeRequest = {
  // Fetch a filtered list of booking statuses based on specific parameters
//   bookingStatusFilteredList: (values) =>
//     api.get(
//       `${API_URL.BASEURL}${API_URL.getBookingStatusFilterSet}`,
//       {
//         withCredentials: true,
//         params: {
//           statusName: values?.statusName,
//           isActive: values?.isActive,
//         }
//       }
//     ),

  // Fetch the list of all booking statuses
  bookingTypeList: () =>
    api.get(
      `${API_URL.BASEURL}${API_URL.getBookingTypeList}`,
      {
        withCredentials: true,
      }
    ),
};

export default BookingTypeRequest;
